import useMultpleTable from '../../../hooks/useMultipleTable';
import { Table } from '../../Table';
import { MultiTableComponentProps } from '../types';

const columnLables = {
  name: {
    name: 'Controlled structure Name'
  },
  lei_code: {
    name: 'Controlled structure LEI code'
  },
  bic_code: {
    name: 'Controlled structure BIC code'
  },
  exposure_value: {
    name: 'Controlled structure Exposure value'
  }
};

export function ControlledStucture({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  onAddColumn,
  onDeleteColumn,
  isMultiFunds
}: MultiTableComponentProps) {
  const { rows, columns, onChange } = useMultpleTable({
    data: funds[currentDataKey]?.fund_data?.CONTROLLED_STRUCTURE,
    onChangeFund,
    schema: schema.CONTROLLED_STRUCTURE,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.CONTROLLED_STRUCTURE?.field_names || [],
    columnLables,
    onAddColumn,
    onDeleteColumn,
    tableName: 'CONTROLLED_STRUCTURE',
    // @ts-ignore
    order: 290,
    isMultiFunds,
    funds,
    hasTableOrderNumber: false
  });

  return (
    <Table
      id="reporttables-controlled-structure-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
